"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createActivitiesStyle;

function createActivitiesStyle() {
  return {
    margin: 0,
    padding: 0
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvQWN0aXZpdGllcy50cyJdLCJuYW1lcyI6WyJjcmVhdGVBY3Rpdml0aWVzU3R5bGUiLCJtYXJnaW4iLCJwYWRkaW5nIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EscUJBQVQsR0FBaUM7QUFDOUMsU0FBTztBQUNMQyxJQUFBQSxNQUFNLEVBQUUsQ0FESDtBQUVMQyxJQUFBQSxPQUFPLEVBQUU7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUFjdGl2aXRpZXNTdHlsZSgpIHtcbiAgcmV0dXJuIHtcbiAgICBtYXJnaW46IDAsXG4gICAgcGFkZGluZzogMFxuICB9O1xufVxuIl19